<main aria-label="Pricing Table">
  <section>
    <div
      class="selection:cpt-text-calenso-white-color selection:cpt-bg-calenso-neon-blue-color"
      [ngClass]="{'cpt-m-5': _renderModeSignal() === sales}"
    >
      @if (_renderModeSignal() === sales) {
        <header class="cpt-text-center md:cpt-flex cpt-justify-between cpt-items-center cpt-mb-9">
          <h1 class="cpt-font-extrabold cpt-text-2xl">
            {{ 'pricing_table.calenso_pricing' | translate }}
          </h1>
          <div class="cpt-text-center md:cpt-flex cpt-gap-5">
            <div class="cpt-text-calenso-steel-blue-color cpt-text-sm md:cpt-text-md" role="group" aria-label="Currency selection">
              <button 
                type="button"
                class="cpt-bg-transparent cpt-border-none cpt-cursor-pointer cpt-p-1 cpt-rounded focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2" 
                [ngClass]="{'cpt-text-calenso-neon-blue-color': _currencySignal() === chf}"
                (click)="setCurrency(chf)"
                [attr.aria-label]="'pricing_table.select_chf_currency' | translate"
                [attr.aria-pressed]="_currencySignal() === chf"
              >CHF</button>
              <span class="cpt-text-calenso-steel-blue-color"> | </span>
              <button 
                type="button"
                class="cpt-bg-transparent cpt-border-none cpt-cursor-pointer cpt-p-1 cpt-rounded focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2" 
                [ngClass]="{'cpt-text-calenso-neon-blue-color': _currencySignal() === eur}"
                (click)="setCurrency(eur)"
                [attr.aria-label]="'pricing_table.select_eur_currency' | translate"
                [attr.aria-pressed]="_currencySignal() === eur"
              >EUR</button>
              <span class="cpt-text-calenso-steel-blue-color"> | </span>
              <button 
                type="button"
                class="cpt-bg-transparent cpt-border-none cpt-cursor-pointer cpt-p-1 cpt-rounded focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2" 
                [ngClass]="{'cpt-text-calenso-neon-blue-color': _currencySignal() === usd}"
                (click)="setCurrency(usd)"
                [attr.aria-label]="'pricing_table.select_usd_currency' | translate"
                [attr.aria-pressed]="_currencySignal() === usd"
              >USD</button>
              <span class="cpt-text-calenso-steel-blue-color"> | </span>
              <button 
                type="button"
                class="cpt-bg-transparent cpt-border-none cpt-cursor-pointer cpt-p-1 cpt-rounded focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2" 
                [ngClass]="{'cpt-text-calenso-neon-blue-color': _currencySignal() === gbp}"
                (click)="setCurrency(gbp)"
                [attr.aria-label]="'pricing_table.select_gbp_currency' | translate"
                [attr.aria-pressed]="_currencySignal() === gbp"
              >GBP</button>
            </div>

            <div class="cpt-text-calenso-steel-blue-color cpt-text-sm md:cpt-text-md" role="group" aria-label="Language selection">
              <button 
                type="button"
                class="cpt-bg-transparent cpt-border-none cpt-cursor-pointer cpt-p-1 cpt-rounded focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2" 
                [ngClass]="{'cpt-text-calenso-neon-blue-color': _languageSignal() === en_US}"
                (click)="setLanguage(en_US)"
                [attr.aria-label]="'pricing_table.select_english_language' | translate"
                [attr.aria-pressed]="_languageSignal() === en_US"
              >English</button>
              <span class="cpt-text-calenso-steel-blue-color"> | </span>
              <button 
                type="button"
                class="cpt-bg-transparent cpt-border-none cpt-cursor-pointer cpt-p-1 cpt-rounded focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2" 
                [ngClass]="{'cpt-text-calenso-neon-blue-color': _languageSignal() === de_CH}"
                (click)="setLanguage(de_CH)"
                [attr.aria-label]="'pricing_table.select_german_language' | translate"
                [attr.aria-pressed]="_languageSignal() === de_CH"
              >German</button>
            </div>
          </div>
        </header>
      }

      <div>
        <div class="cpt-border cpt-border-solid cpt-rounded cpt-p-3 cpt-text-base cpt-font-semibold">
          <div class="cpt-flex cpt-flex-col-reverse cpt-items-center cpt-gap-3 md:cpt-flex-row md:cpt-justify-between">
            @if (_showCustomPlanSectionSignal()) {
              <div class="cpt-text-sm md:cpt-text-md">
                <button 
                  type="button"
                  class="cpt-bg-transparent cpt-border-none cpt-text-calenso-neon-blue-color cpt-cursor-pointer cpt-border-b-2 cpt-border-calenso-neon-blue-color cpt-p-1 cpt-rounded focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2" 
                  (click)="toggleUserProfile()"
                  [attr.aria-label]="isCustomPlanSelectionEnabledSignal() ? ('pricing_table.close_custom_plan' | translate) : ('pricing_table.open_custom_plan' | translate)"
                  [attr.aria-expanded]="isCustomPlanSelectionEnabledSignal()"
                >
                  @if(isCustomPlanSelectionEnabledSignal()) {
                    {{ "pricing_table.close" | translate }}
                  } @else {
                    {{ "pricing_table.manage_user_profile" | translate }}
                  }
                </button>
              </div>
            } @else {
              <div></div>
            }

            <div class="cpt-text-calenso-steel-blue-color cpt-text-sm md:cpt-text-md" dir="rtl">
              @if (!_hideMonthlyIntervalSignal()) {
                <span class="cpt-cursor-pointer" [ngClass]="{'cpt-text-calenso-neon-blue-color': _intervalSignal() === monthly}"
                  (click)="toggleInterval(monthly)">{{ "pricing_table.monthly" | translate }}</span> |
              }
              <span class="cpt-cursor-pointer" [ngClass]="{'cpt-text-calenso-neon-blue-color': _intervalSignal() === yearly}"
                (click)="toggleInterval(yearly)">{{ "pricing_table.annual" | translate }}
                <span class="cpt-ml-1 cpt-rounded cpt-bg-calenso-powder-blue-color cpt-px-2 cpt-py-1">{{
                  "pricing_table.save_10" | translate }}</span>
              </span>
              @if (_renderModeSignal() === sales && this._showMoreIntervalSignal()) {
                | <span class="cpt-cursor-pointer" [ngClass]="{'cpt-text-calenso-neon-blue-color': _intervalSignal() === year_2}"
                  (click)="toggleInterval(year_2)">{{ "pricing_table.year_2" | translate }}
                    <span class="cpt-ml-1 cpt-rounded cpt-bg-calenso-powder-blue-color cpt-px-2 cpt-py-1">{{
                    "pricing_table.save_15" | translate }}</span>
                </span>
                | <span class="cpt-cursor-pointer" [ngClass]="{'cpt-text-calenso-neon-blue-color': _intervalSignal() === year_3}"
                  (click)="toggleInterval(year_3)">{{ "pricing_table.year_3" | translate }}
                  <span class="cpt-ml-1 cpt-rounded cpt-bg-calenso-powder-blue-color cpt-px-2 cpt-py-1">{{
                    "pricing_table.save_20" | translate }}</span>
                </span>
              }
            </div>
          </div>
        </div>
        @if (isCustomPlanSelectionEnabledSignal() && _showCustomPlanSectionSignal()) {
          <section aria-label="Custom Plan Selection" class="cpt-border cpt-border-solid cpt-rounded cpt-mt-4 cpt-p-3 cpt-text-base cpt-font-semibold">
            <div class="cpt-grid cpt-gap-2 md:cpt-grid-cols-2 lg:cpt-grid-cols-4">
              <div class="cpt-text-center">
                <h3 class="calenso-custom-plan-title cpt-text-lg cpt-font-semibold cpt-mb-2">{{ "pricing_table.change_number_of_user" | translate }}</h3>
                <p class="calenso-custom-plan-subtitle cpt-text-sm cpt-mb-3">{{ "pricing_table.user_choose_number" | translate }}:</p>
                <div class="cpt-flex cpt-flex-col cpt-mt-2 cpt-gap-3 md:cpt-flex-row md:cpt-justify-between">
                  <div class="cpt-flex cpt-justify-center md:cpt-justify-start cpt-gap-2" role="group" aria-label="User count controls">
                    <button
                      class="calenso-button outline cpt-w-9 focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2"
                      [disabled]="customPlanUserSignal() <= minLimit"
                      (click)="decrement(customPlanUserType)"
                      [attr.aria-label]="'pricing_table.decrement_user' | translate"
                    >
                    <ng-container [ngTemplateOutlet]="decrementButtonText" />
                    </button>
                    <input
                      type="number"
                      name="userCount"
                      class="calenso-input focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2"
                      [(ngModel)]="customPlanUserSignal"
                      appMaxInputValue="{{ maxLimit }}"
                      (keyup)="changeUserProfile(customPlanUserSignal(), customPlanUserType)"
                      [attr.aria-label]="'pricing_table.user_number_input' | translate"
                      min="{{ minLimit }}"
                      max="{{ maxLimit }}"
                    >
                    <button
                      class="calenso-button outline cpt-w-9 focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2"
                      [disabled]="customPlanUserSignal() >= maxLimit"
                      (click)="increment(customPlanUserType)"
                      [attr.aria-label]="'pricing_table.increment_user' | translate"
                    >
                      <ng-container [ngTemplateOutlet]="incrementButtonText" />
                    </button>
                  </div>
                </div>
              </div>
              <div class="cpt-text-center">
                <h3 class="calenso-custom-plan-title cpt-text-lg cpt-font-semibold cpt-mb-2">{{ "pricing_table.change_number_of_store" | translate }}</h3>
                <p class="calenso-custom-plan-subtitle cpt-text-sm cpt-mb-3">{{ "pricing_table.store_choose_number" | translate }}:</p>
                <div class="cpt-flex cpt-flex-col cpt-mt-2 cpt-gap-3 md:cpt-flex-row md:cpt-justify-between">
                  <div class="cpt-flex cpt-justify-center md:cpt-justify-start cpt-gap-2" role="group" aria-label="Store count controls">
                    <button
                      class="calenso-button outline cpt-w-9 focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2"
                      [disabled]="customPlanStoreSignal() <= minLimit"
                      (click)="decrement(customPlanStoreType)"
                      [attr.aria-label]="'pricing_table.decrement_store' | translate"
                    >
                      <ng-container [ngTemplateOutlet]="decrementButtonText" />
                    </button>
                    <input
                      type="number"
                      name="storeCount"
                      class="calenso-input focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2"
                      [(ngModel)]="customPlanStoreSignal"
                      appMaxInputValue="{{ maxLimit }}"
                      (keyup)="changeUserProfile(customPlanStoreSignal(), customPlanStoreType)"
                      [attr.aria-label]="'pricing_table.store_number_input' | translate"
                      min="{{ minLimit }}"
                      max="{{ maxLimit }}"
                    >
                    <button
                      class="calenso-button outline cpt-w-9 focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2"
                      [disabled]="customPlanStoreSignal() >= maxLimit"
                      (click)="increment(customPlanStoreType)"
                      [attr.aria-label]="'pricing_table.increment_store' | translate"
                    >
                      <ng-container [ngTemplateOutlet]="incrementButtonText" />
                    </button>
                  </div>
                </div>
              </div>
              <div class="cpt-text-center">
                <h3 class="calenso-custom-plan-title cpt-text-lg cpt-font-semibold cpt-mb-2">{{ "pricing_table.change_number_of_group_appointment" | translate }}</h3>
                <p class="calenso-custom-plan-subtitle cpt-text-sm cpt-mb-3">{{ "pricing_table.group_appointment_choose_number" | translate }}:</p>
                <div class="cpt-flex cpt-flex-col cpt-mt-2 cpt-gap-3 md:cpt-flex-row md:cpt-justify-between">
                  <div class="cpt-flex cpt-justify-center md:cpt-justify-start cpt-gap-2" role="group" aria-label="Group appointment count controls">
                    <button
                      class="calenso-button outline cpt-w-9 focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2"
                      [disabled]="customPlanGroupAppointmentSignal() <= minLimit"
                      (click)="decrement(customPlanGroupAppointmentType)"
                      [attr.aria-label]="'pricing_table.decrement_group_appointment' | translate"
                    >
                      <ng-container [ngTemplateOutlet]="decrementButtonText" />
                    </button>
                    <input
                      type="number"
                      name="groupAppointmentCount"
                      class="calenso-input focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2"
                      [(ngModel)]="customPlanGroupAppointmentSignal"
                      appMaxInputValue="{{ maxLimit }}"
                      (keyup)="changeUserProfile(customPlanGroupAppointmentSignal(), customPlanGroupAppointmentType)"
                      [attr.aria-label]="'pricing_table.group_appointment_number_input' | translate"
                      min="{{ minLimit }}"
                      max="{{ maxLimit }}"
                    >
                    <button
                      class="calenso-button outline cpt-w-9 focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2"
                      [disabled]="customPlanGroupAppointmentSignal() >= maxLimit"
                      (click)="increment(customPlanGroupAppointmentType)"
                      [attr.aria-label]="'pricing_table.increment_group_appointment' | translate"
                    >
                      <ng-container [ngTemplateOutlet]="incrementButtonText" />
                    </button>
                  </div>
                </div>
              </div>
              <div class="cpt-text-center">
                <h3 class="calenso-custom-plan-title cpt-text-lg cpt-font-semibold cpt-mb-2">{{ "pricing_table.change_number_of_conference" | translate }}</h3>
                <p class="calenso-custom-plan-subtitle cpt-text-sm cpt-mb-3">{{ "pricing_table.conference_choose_number" | translate }}:</p>
                <div class="cpt-flex cpt-flex-col cpt-mt-2 cpt-gap-3 md:cpt-flex-row md:cpt-justify-between">
                  <div class="cpt-flex cpt-justify-center md:cpt-justify-start cpt-gap-2" role="group" aria-label="Conference count controls">
                    <button
                      class="calenso-button outline cpt-w-9 focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2"
                      [disabled]="customPlanConferenceSignal() <= minConferenceLimit"
                      (click)="decrement(customPlanConferenceType)"
                      [attr.aria-label]="'pricing_table.decrement_conference' | translate"
                    >
                      <ng-container [ngTemplateOutlet]="decrementButtonText" />
                    </button>
                    <input
                      type="number"
                      name="conferenceCount"
                      class="calenso-input focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2"
                      [(ngModel)]="customPlanConferenceSignal"
                      appMaxInputValue="{{ maxLimit }}"
                      (keyup)="changeUserProfile(customPlanConferenceSignal(), customPlanConferenceType)"
                      [attr.aria-label]="'pricing_table.conference_number_input' | translate"
                      min="{{ minConferenceLimit }}"
                      max="{{ maxLimit }}"
                    >
                    <button
                      class="calenso-button outline cpt-w-9 focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2"
                      [disabled]="customPlanConferenceSignal() >= maxLimit"
                      (click)="increment(customPlanConferenceType)"
                      [attr.aria-label]="'pricing_table.increment_conference' | translate"
                    >
                      <ng-container [ngTemplateOutlet]="incrementButtonText" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Custom plan pricing calculation start -->
            <div class="cpt-mt-4 cpt-flex cpt-justify-center md:cpt-justify-end md:cpt-self-end">
              <div class="cpt-max-w-fit cpt-text-center md:cpt-text-right">
                <div class="cpt-text-center md:cpt-text-left">
                  @if (customSelectedPlanSignal()?.id !== enterpriseId || _renderModeSignal() === sales) {
                    <div class="cpt-text-2xl cpt-font-bold" role="text" aria-label="Custom plan total price">
                      {{ currencySymbolSignal() }} {{ customPlanTotalAmountSignal() | number: decimalDigits: decimalLocal }}
                      <span class="cpt-text-md cpt-font-normal"> / {{ "pricing_table.month" | translate }}</span>
                    </div>
                    @if (
                      customSelectedPlanSignal()?.min_workers < customPlanUserSignal() ||
                      customSelectedPlanSignal()?.min_store < customPlanStoreSignal() ||
                      customSelectedPlanSignal()?.min_group_appointment < customPlanGroupAppointmentSignal() ||
                      customSelectedPlanSignal()?.min_conference < customPlanConferenceSignal()
                    ) {
                      <div class="cpt-w-full cpt-border-b-2 cpt-border-calenso-powder-blue-color cpt-my-2"></div>
                    }
                    <div class="cpt-text-sm" role="list" aria-label="Additional charges">
                      @if (customSelectedPlanSignal()?.min_workers < customPlanUserSignal()) {
                        <div role="listitem">
                          <ng-container [ngTemplateOutlet]="incrementButtonText" />
                          @if((customPlanUserSignal() - customSelectedPlanSignal()?.min_workers) === 1) {
                            {{ customPlanUserSignal() - customSelectedPlanSignal()?.min_workers }} {{ "pricing_table.per_user_calender" | translate }}
                          } @else {
                            {{ customPlanUserSignal() - customSelectedPlanSignal()?.min_workers }} {{ "pricing_table.per_user_calenders" | translate }}
                          }
                        </div>
                      }
                      @if (customSelectedPlanSignal()?.min_store < customPlanStoreSignal()) {
                        <div role="listitem">
                          <ng-container [ngTemplateOutlet]="incrementButtonText" />
                          @if((customPlanStoreSignal() - customSelectedPlanSignal()?.min_store) === 1) {
                            {{ customPlanStoreSignal() - customSelectedPlanSignal()?.min_store }} {{ "pricing_table.per_store" | translate }}
                          } @else {
                            {{ customPlanStoreSignal() - customSelectedPlanSignal()?.min_store }} {{ "pricing_table.per_stores" | translate }}
                          }
                        </div>
                      }
                      @if (customSelectedPlanSignal()?.min_group_appointment < customPlanGroupAppointmentSignal()) {
                        <div role="listitem">
                          <ng-container [ngTemplateOutlet]="incrementButtonText" />
                          @if((customPlanGroupAppointmentSignal() - customSelectedPlanSignal()?.min_group_appointment) === 1) {
                            {{ customPlanGroupAppointmentSignal() - customSelectedPlanSignal()?.min_group_appointment }} {{ "pricing_table.per_group_appointment" | translate }}
                          } @else {
                            {{ customPlanGroupAppointmentSignal() - customSelectedPlanSignal()?.min_group_appointment }} {{ "pricing_table.per_group_appointments" | translate }}
                          }
                        </div>
                      }
                      @if (customSelectedPlanSignal()?.min_conference < customPlanConferenceSignal()) {
                        <div role="listitem">
                          <ng-container [ngTemplateOutlet]="incrementButtonText" />
                          @if((customPlanConferenceSignal() - customSelectedPlanSignal()?.min_conference) === 1) {
                            {{ customPlanConferenceSignal() - customSelectedPlanSignal()?.min_conference }} {{ "pricing_table.per_conference" | translate }}
                          } @else {
                            {{ customPlanConferenceSignal() - customSelectedPlanSignal()?.min_conference }} {{ "pricing_table.per_conferences" | translate }}
                          }
                        </div>
                      }
                    </div>
                  } @else {
                    <div class="cpt-text-center md:cpt-text-right">
                      <span class="cpt-text-2xl cpt-font-bold">
                        {{ "pricing_table.price_on_request" | translate }}
                      </span>
                    </div>
                  }
                </div>
              </div>
            </div>
            <!-- Custom plan pricing calculation end -->
          </section>
        }
        <div class="cpt-flex cpt-gap-6 md:cpt-gap-3 lg:cpt-gap-6 cpt-flex-col md:cpt-flex-row cpt-mt-6">
          @for (plan of pricingListSignal(); track plan.id) {
            <article
              [ngClass]="{
                'active-plan': (
                _renderModeSignal() === dashboard &&
                plan.id === _currentSubscriptionSignal()?.subscription_type_id &&
                _intervalSignal() === _currentSubscriptionSignal()?.subscription_interval),
                'popular-plan':(
                  plan.name === _popularPlanSignal() &&
                  _currentSubscriptionSignal()?.subscription_type_id !== subscriptionIds[_popularPlanSignal()]
                ),
                'cpt-opacity-50 disabled-plan': !availablePlansSignal().includes(plan.id)
              }"
              class="popular-plan pricing-card cpt-bg-calenso-powder-blue-color cpt-p-3 cpt-pt-5 cpt-pb-14 cpt-rounded cpt-relative cpt-flex-1 [&.popular-plan]:cpt-bg-calenso-neon-blue-color"
              [attr.aria-label]="plan.subscription_title + ' pricing plan'"
            >
              <div class="-cpt-mt-5 cpt-flex cpt-justify-center cpt-gap-2">
                <!-- active-plan -->
                <div class="cpt-hidden -cpt-mb-3.5 -cpt-mt-3.5 [.active-plan_&]:cpt-block cpt-text-calenso-white-color cpt-bg-caleno-green-color cpt-max-w-fit cpt-font-semibold cpt-text-sm md:cpt-text-xs lg:cpt-text-sm cpt-p-1 cpt-px-3 cpt-rounded-md" role="status" aria-label="Current active plan">
                  {{ "pricing_table.active" | translate }}
                </div>
                <!-- popular-plan -->
                <div class="cpt-hidden -cpt-mb-3.5 -cpt-mt-3.5 [.popular-plan_&]:cpt-block cpt-text-calenso-neon-blue-color cpt-bg-calenso-powder-blue-color cpt-max-w-fit cpt-font-semibold cpt-text-sm md:cpt-text-xs lg:cpt-text-sm cpt-p-1 cpt-px-3 cpt-rounded-md" role="status" aria-label="Best value plan">
                  {{ "pricing_table.best_value" | translate }}
                </div>
              </div>
              <!-- Name -->
              <h2
                class="cpt-mt-10 cpt-text-3xl md:cpt-text-2xl lg:cpt-text-3xl cpt-capitalize cpt-font-bold cpt-text-calenso-neon-blue-color [.popular-plan_&]:cpt-text-calenso-white-color">
                {{ plan.subscription_title }}
              </h2>
              <!-- Description -->
              <p
                class="cpt-mt-3 cpt-text-sm md:cpt-text-xs lg:cpt-text-sm cpt-font-medium md:cpt-min-h-[130px] lg:cpt-min-h-[120px] xl:cpt-min-h-[100px] [.popular-plan_&]:cpt-text-calenso-white-color">
                {{ plan.subscription_subtitle[_languageSignal()] }}
              </p>
              <!-- Price -->
              <div class="cpt-mt-8 [.popular-plan_&]:cpt-text-calenso-white-color">
                <span class="cpt-text-3xl cpt-font-bold md:cpt-text-2xl lg:cpt-text-3xl">
                  @if (!plan.price_on_request) {
                    {{ currencySymbolSignal() }}
                    @if (_showUserBasedPricingSignal()) {
                      {{ plan?.[_currencySignal() | lowercase]?.[_intervalSignal()]?.original_price }}
                      <span class="cpt-text-sm md:cpt-text-xs lg:cpt-text-sm cpt-font-medium">
                        / {{ "pricing_table.per_user_calender" | translate }}
                      </span>
                    } @else {
                      @if (plan?.name === appliedPlanSignal()?.name) {
                        {{ customPlanTotalAmountSignal() | number: decimalDigits: decimalLocal }}
                      } @else {
                        {{ plan?.[_currencySignal() | lowercase]?.[_intervalSignal()]?.original_price | number: decimalDigits: decimalLocal}}
                      }
                      <span class="cpt-text-sm md:cpt-text-xs lg:cpt-text-sm cpt-font-medium">
                        / {{ "pricing_table.month" | translate }}
                      </span>
                    }
                  } @else {
                    @if (_renderModeSignal() === website) {
                      <img width="50" height="50" src="{{ deployUrl + '/assets/images/chat_enteprise_pricing_black.svg' }}" alt="Enterprise pricing icon" class="cpt-w-9 cpt-h-9 cpt-bg-calenso-powder-blue-color [.popular-plan_&]:cpt-hidden">
                      <img width="50" height="50" src="{{ deployUrl + '/assets/images/chat_enteprise_pricing_white.svg' }}" alt="Enterprise pricing icon" class="cpt-w-9 cpt-h-9 cpt-hidden cpt-bg-calenso-neon-blue-color [.popular-plan_&]:cpt-block">
                    } @else {
                      {{ "pricing_table.upon_request" | translate }}
                    }
                  }
                  @if (!plan.price_on_request) {
                    <div class="cpt-text-xs cpt-font-medium cpt-text-calenso-steel-blue-color [.popular-plan_&]:cpt-text-calenso-powder-blue-color">
                      @if (_showUserBasedPricingSignal()) {
                        + {{extraUserCost}} {{_currencySignal()}} {{ "pricing_table.extra_user_charge" | translate }}
                      } @else {
                        @if (_intervalSignal() === monthly) {
                          {{ "pricing_table.charged_monthly" | translate }}
                        } @else {
                          {{ "pricing_table.charged_annually" | translate }}
                        }
                      }
                    </div>
                  } @else {
                    @if (_renderModeSignal() === website) {
                      <div class="cpt-text-xs cpt-font-medium cpt-text-calenso-steel-blue-color [.popular-plan_&]:cpt-text-calenso-powder-blue-color">
                        {{ "pricing_table.price_on_request" | translate }}
                      </div>
                    } @else {
                      <div class="cpt-h-4"></div>
                    }
                  }
                </span>
              </div>
              <!-- Upgrade button -->
              @if (_renderModeSignal() !== sales) {
                <div class="cpt-mt-5">
                  <ng-container [ngTemplateOutlet]="planUpgradeButton" [ngTemplateOutletContext]="{ plan: plan }" />
                </div>
              }
              <!-- Feature list -->
              <div class="cpt-mt-6 [.popular-plan_&]:cpt-text-calenso-white-color">
                <h3 class="cpt-text-sm md:cpt-text-xs lg:cpt-text-sm cpt-font-bold cpt-mb-5">
                  {{ plan.feature_list_title[_languageSignal()] }}:
                </h3>

                <ul class="cpt-list-none cpt-p-0 cpt-m-0" role="list">
                  @for (feature of plan.feature_list[_renderModeSignal()]; track feature[_languageSignal()]) {
                    @if ((feature?.show_user_base_price === true && _showUserBasedPricingSignal()) || feature?.show_user_base_price === undefined) {
                      <li
                        class="cpt-mt-4 cpt-flex cpt-items-center"
                        [ngClass]="{'cpt-opacity-50': feature?.include === false}"
                        role="listitem"
                      >
                        <div
                          class="cpt-bg-calenso-neon-blue-color cpt-flex cpt-justify-center cpt-items-center cpt-w-5 cpt-min-w-5 cpt-h-5 cpt-rounded-[50%] cpt-self-start [.popular-plan_&]:cpt-text-calenso-white-color"
                          [attr.aria-hidden]="true">
                          @if (_renderModeSignal() === website) {
                            <img width="24" height="24" src="{{ deployUrl + '/assets/images/check_pricing_icon_black.svg' }}" alt=""
                              class="cpt-w-5 cpt-h-5 cpt-min-w-[20px] cpt-bg-calenso-powder-blue-color [.popular-plan_&]:cpt-hidden">
                            <img width="24" height="24" src="{{ deployUrl + '/assets/images/check_pricing_icon_white.svg' }}" alt=""
                              class="cpt-w-5 cpt-h-5 cpt-min-w-[20px] cpt-hidden cpt-bg-calenso-neon-blue-color [.popular-plan_&]:cpt-block">
                          } @else {
                            @if (feature?.include === false) {
                              <img width="24" height="24" src="{{ deployUrl + '/assets/images/cancel_violet.svg' }}" alt=""
                                class="cpt-w-5 cpt-h-5 cpt-min-w-[20px] cpt-bg-calenso-powder-blue-color [.popular-plan_&]:cpt-hidden">
                              <img width="24" height="24" src="{{ deployUrl + '/assets/images/cancel_white.svg' }}" alt=""
                                class="cpt-w-5 cpt-h-5 cpt-min-w-[20px] cpt-hidden cpt-bg-calenso-neon-blue-color [.popular-plan_&]:cpt-block">
                            } @else {
                              <img width="24" height="24" src="{{ deployUrl + '/assets/images/checkmark_violet.svg' }}" alt=""
                                class="cpt-w-5 cpt-h-5 cpt-min-w-[20px] cpt-bg-calenso-powder-blue-color [.popular-plan_&]:cpt-hidden">
                              <img width="24" height="24" src="{{ deployUrl + '/assets/images/checkmark_white.svg' }}" alt=""
                                class="cpt-w-5 cpt-h-5 cpt-min-w-[20px] cpt-hidden cpt-bg-calenso-neon-blue-color [.popular-plan_&]:cpt-block">
                            }
                          }
                        </div>
                        <span
                          class="cpt-ms-3 cpt-text-sm md:cpt-text-xs lg:cpt-text-sm cpt-font-medium cpt-word-break"
                          [innerHTML]="feature[_languageSignal()] | calioSafe: 'html'"
                        >
                        </span>
                      </li>
                    }
                  }
                </ul>
              </div>
              <!-- Compare feature link -->
              @if (_renderModeSignal() === website) {
                <div class="cpt-absolute cpt-bottom-0 cpt-my-2">
                  <button
                    type="button"
                    class="cpt-mt-3 cpt-text-sm md:cpt-text-xs cpt-text-calenso-neon-blue-color cpt-cursor-pointer cpt-font-medium cpt-italic cpt-flex cpt-items-center cpt-bg-transparent cpt-border-none cpt-p-1 cpt-rounded focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2 [.popular-plan_&]:cpt-text-calenso-white-color [.disabled-plan_&]:cpt-pointer-events-none"
                    (click)="compareFeatureList()"
                    [attr.aria-label]="'pricing_table.compare_all_features' | translate"
                  >
                    {{ "pricing_table.compare_all_features" | translate }}
                    <span
                      class="cpt-ms-4 cpt-block cpt-w-2 cpt-h-2 cpt-border-t cpt-border-solid cpt-border-calenso-neon-blue-color cpt-rotate-[135deg] cpt-border-l after:cpt-content-[''] after:cpt-block after:cpt-w-px after:cpt-h-[15px] after:cpt-bg-calenso-neon-blue-color after:cpt-rotate-[-45deg] after:cpt-translate-x-[5px] after:cpt-translate-y-[-2px] after:cpt-left-0 after:cpt-top-0 [.popular-plan_&]:cpt-border-calenso-white-color [.popular-plan_&]:after:cpt-bg-calenso-white-color"
                      aria-hidden="true"
                    ></span>
                  </button>
                </div>
              }
            </article>
          }
        </div>
      </div>

      @if (_renderModeSignal() === sales) {
        <footer class="cpt-mt-10 cpt-text-center cpt-text-sm"
          [innerHTML]="'pricing_table.rights_reserved' | translate: { year: currentYear } | calioSafe: 'html'"
        >
        </footer>
      }
    </div>
  </section>
</main>

<ng-template #planUpgradeButton let-plan="plan">
  @if (_renderModeSignal() === website) {
    @if (plan.id === subscriptionIds.basic) {
      <ng-container [ngTemplateOutlet]="planButtonText" [ngTemplateOutletContext]="{ plan: plan , buttonText: 'get_start_for_free' }" />
    } @else if (plan.id === subscriptionIds.premium) {
      <ng-container [ngTemplateOutlet]="planButtonText" [ngTemplateOutletContext]="{ plan: plan , buttonText: 'free_trial' }" />
    } @else if (plan.id === subscriptionIds.business) {
      <ng-container [ngTemplateOutlet]="planButtonText" [ngTemplateOutletContext]="{ plan: plan , buttonText: 'days_14_free_trial' }" />
    } @else if (plan.id === subscriptionIds.enterprise) {
      <ng-container [ngTemplateOutlet]="planButtonText" [ngTemplateOutletContext]="{ plan: plan , buttonText: 'contact_us' }" />
    }
  }
  @if (_renderModeSignal() === dashboard) {
    @if(!isPartnerInTrialModeSignal()) {
      @if (currentPlanPrecedenceSignal() === pricingPlanPrecedence[plan.id]) {
        @if(_currentSubscriptionSignal()?.subscription_interval === monthly && _intervalSignal() === monthly) {
          <ng-container [ngTemplateOutlet]="emptyButtonText" />
        } @else if (_currentSubscriptionSignal()?.subscription_interval === monthly && _intervalSignal() === yearly) {
          @if (!plan?.price_on_request) {
            <ng-container [ngTemplateOutlet]="planButtonText" [ngTemplateOutletContext]="{ plan: plan , buttonText: 'change_your_subscription' }" />
          } @else {
            <ng-container [ngTemplateOutlet]="planButtonText" [ngTemplateOutletContext]="{ plan: plan , buttonText: 'request_now' }" />
          }
        } @else {
          <ng-container [ngTemplateOutlet]="emptyButtonText" />
        }
      } @else if (currentPlanPrecedenceSignal() > pricingPlanPrecedence[plan.id]) {
        <ng-container [ngTemplateOutlet]="emptyButtonText" />
      } @else if ((currentPlanPrecedenceSignal() < pricingPlanPrecedence[plan.id]) || !currentPlanPrecedenceSignal()) {
        @if (!plan?.price_on_request) {
          <ng-container [ngTemplateOutlet]="planButtonText" [ngTemplateOutletContext]="{ plan: plan , buttonText: 'upgrade_now' }" />
        } @else {
          <ng-container [ngTemplateOutlet]="planButtonText" [ngTemplateOutletContext]="{ plan: plan , buttonText: 'request_now' }" />
        }
      }
    }@else {
      @if (!plan?.price_on_request) {
        <ng-container [ngTemplateOutlet]="planButtonText" [ngTemplateOutletContext]="{ plan: plan , buttonText: 'upgrade_now' }" />
      } @else {
        <ng-container [ngTemplateOutlet]="planButtonText" [ngTemplateOutletContext]="{ plan: plan , buttonText: 'request_now' }" />
      }
    }
  }
</ng-template>

<ng-template #planButtonText let-buttonText="buttonText" let-plan="plan">
  <button
    class="cpt-text-base md:cpt-text-sm lg:cpt-text-base cpt-font-medium cpt-w-full cpt-h-12 cpt-bg-calenso-neon-blue-color cpt-text-calenso-white-color cpt-rounded focus:cpt-outline-none focus:cpt-ring-2 focus:cpt-ring-calenso-neon-blue-color focus:cpt-ring-offset-2 [.popular-plan_&]:cpt-bg-calenso-white-color [.popular-plan_&]:cpt-text-calenso-black-color [.disabled-plan_&]:cpt-pointer-events-none"
    (click)="submit(plan,_intervalSignal(),_currencySignal())"
    [attr.aria-label]="'pricing_table.' + buttonText | translate"
  >
    {{ "pricing_table." + buttonText | translate }}
  </button>
</ng-template>

<ng-template #emptyButtonText>
  <div class="cpt-h-12"></div>
</ng-template>

<ng-template #incrementButtonText>
  +
</ng-template>

<ng-template #decrementButtonText>
  -
</ng-template>
